<template>
    <div class="table-date">
        <div v-if="date"> {{ $moment(date).format("DD.MM.YYYY") }}</div>
        <div v-if="date"> {{ $moment(date).format("HH:mm") }}</div>

    </div>
</template>
<script>
    export default {
        props: ['date']
    }
</script>
<style lang="scss">
</style>
